import { Delete } from '@wix/wix-ui-icons-common/lazy';
import { Spinner, IconButton } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import { DATA_HOOKS } from '../dataHooks';
import { st, classes } from '../FileUpload.st.css';
const FileUploadIndicator = ({ state, onDeleteClick, deleteButtonRef, 'aria-label': ariaLabel })=>{
    if (state === 'uploading') {
        return /*#__PURE__*/ React.createElement(Spinner, {
            "data-hook": DATA_HOOKS.spinner,
            className: classes.spinner
        });
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: st(classes.delete, {
            error: state === 'error'
        })
    }, /*#__PURE__*/ React.createElement(IconButton, {
        innerRef: deleteButtonRef,
        "data-hook": DATA_HOOKS.delete,
        onClick: onDeleteClick,
        "aria-label": ariaLabel,
        icon: /*#__PURE__*/ React.createElement(Delete, {
            "aria-hidden": "true"
        })
    }));
};
export default FileUploadIndicator;

//# sourceMappingURL=FileUploadIndicator.js.map